<template>
    <div class="container help" v-if="show">
        <div class="text-center py-4">
            <div class="jumbotron eyecatch">
                <h2 class="mincho">ヘルプ</h2>
                <p>
                    <strong>
                        貸し本棚の使い方を際しています。<br>
                        不足している情報があればお問い合わせください。
                    </strong>
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <h4>ユーザーアカウント</h4>
                <account-menu></account-menu>
                <h4>記事を書く</h4>
                <article-menu></article-menu>
            </div>
            <div class="col-lg-4">
                <h4>小説を書く</h4>
                <novel-menu></novel-menu>
            </div>
            <div class="col-lg-4">
                <h4>小説を読む</h4>
                <read-menu></read-menu>
                <h4>その他</h4>
                <other-menu></other-menu>
            </div>
        </div>
    </div>
</template>

<style src="./help.scss" scoped lang="scss"></style>

<script>
import accountMenu from "./account/account-menu";
import novelMenu from "./novel/novel-menu";
import readMenu from "./read/read-menu";
import otherMenu from "./other/other-menu";
import articleMenu from "./article/article-menu";
export default {
    components: {
        accountMenu,
        novelMenu,
        readMenu,
        otherMenu,
        articleMenu,
    },
    data() {
        return {
            show: true
        }
    },
    created() {
        this.useHead({
            title: "ヘルプセンター | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>